import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleBudgetKindItem } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheBudgetKindItemComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const budgetKindItemCombo = computed(() => {
    const budgetKindItems = store.getters[`${ModuleBudgetKindItem}/items`];
    return budgetKindItems.filter(x => !x.inactive && x.grade == 1);
  });
  const budgetSubKindItemCombo = computed(() => {
    const budgetSubKindItems = store.getters[`${ModuleBudgetKindItem}/items`];
    return budgetSubKindItems.filter(x => !x.inactive && !x.is_parent);
  });

  // config columns combo
  const cacheBudgetKindItemComboConfig = reactive({
    data: budgetKindItemCombo,
    columns: [
      {
        title: 'Mã loại',
        dataField: 'budget_kind_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên loại',
        dataField: 'budget_kind_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_kind_item_code',
    valueField: 'budget_kind_item_code',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'budget_kind_item_code',
      titleSearch: 'Tìm nhanh khoản',
    },
  });

  const cacheBudgetSubKindItemComboConfig = reactive({
    data: budgetSubKindItemCombo,
    columns: [
      {
        title: 'Mã khoản',
        dataField: 'budget_kind_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên khoản',
        dataField: 'budget_kind_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_kind_item_code',
    valueField: 'budget_kind_item_code',
    modelValueField: 'budget_sub_kind_item_code',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'budget_kind_item_code',
      titleSearch: 'Tìm nhanh khoản',
    },
  });

  return { cacheBudgetKindItemComboConfig, cacheBudgetSubKindItemComboConfig };
};
